import { Loading } from '@p2p/components';
import { useGetMerchantOrderQuery } from '@p2p/services';
import { isAlfaPageDesign } from '@p2p/shared/constants';
import { useParams } from 'react-router-dom';
import { usePageSettingsQuery } from 'redux/services/PaymentPagesApi/PaymentPagesApi';

import { NotFoundErrorPage } from '../../../Errors';
import { AlfaQrInvoice } from '../AlfaQrInvoice';
import { TransferInvoice } from './TransferInvoice';

export const TransferInvoicePage = () => {
  const { id = '' } = useParams<{ id: string }>();
  const { isLoading, data: order } = useGetMerchantOrderQuery(id);
  const { data: pageSettings, isLoading: isLoadingPageSettings } = usePageSettingsQuery(
    { design: order?.payment_form, order_id: id },
    { skip: !order },
  );

  if (isLoading || isLoadingPageSettings) {
    return <Loading />;
  }

  if (!order || !pageSettings) {
    return <NotFoundErrorPage />;
  }

  // P2P-3116: alfa_page - тот же экран в новом дизайне.
  if (isAlfaPageDesign(order.payment_form)) {
    return <AlfaQrInvoice order={order} paramId={id} pageSettings={pageSettings} />;
  }

  return <TransferInvoice order={order} paramId={id} pageSettings={pageSettings} />;
};
